import { API_PATHS } from "../constants/api-paths";
import { IResponse, encryptedRequest } from "../core/api.client";

export interface IHlInsertApiRequest {
  mobileNo: string;
  journeyName: string;
  icorsofferId?: string;
  loanAmount?: string;
  loanTenure?: string;
  EMI?: string;
  ROI?: string;
  loanVariant?: string;
  appId?: string;
  appVersion?: string;
  offerId?: string;
  offerIdBhflHlFresh?: string;
  offerIdAfhoFresh?: string;
  offerIdBhflHlBt?: string;
  offerIdAfhoBt?: string;
  offerIdSmelapFresh?: string;
  offerIdSmelapBt?: string;
  offerIdBhflLapFresh?: string;
  offerIdBhflLapBt?: string;
  pdpEntry?: string;
  pdpUrl?: string;
  employmentType?: string;
  sourcingCategory?: string;
  offerSource?: string;
  offerROI?: string;
  offerAmount?: string;
  offerTenor?: string;
  offerName?: string;
  offerID?: string;
  customerConsent?: string;
  grossTurnover?: string;
  sourcingChannel?: string;
  sourceSystem?: string;
}

export interface IHlInsertApiResponse {
  id: string;
  description?: string;
  statusCode?: string;
  eventCode?: string;
  offerId?: string;
  approvedLoanAmount?: string;
  txId?: string;
  ROI?: string;
  journeyName?: string;
  leadAllocation?: string;
}

export const postHlInsert = async (
  hlInsertRequestData: IHlInsertApiRequest
): Promise<IResponse<IHlInsertApiResponse>> => {
  const response = await encryptedRequest<IHlInsertApiResponse, IHlInsertApiRequest>({
    method: "POST",
    url: API_PATHS.hlInsert,
    data: hlInsertRequestData,
  });

  return response;
};
